import { FC } from 'react'
import { useSelector } from 'react-redux'
import getTextVisibleLength from 'helpers/getTextVisibleLength'
import { cn, TooltipWrapper } from '@wellesley/ui'
import { platformSettingsSlice } from '@wellesley/settings'

type TCharsCounter = {
  text: string
}

const CharsCounter: FC<TCharsCounter> = ({ text }) => {
  const postSizeLimit = useSelector(
    platformSettingsSlice.selectors.selectPostConfig,
  )?.max_characters

  const currentTextLength = getTextVisibleLength(text)
  const diff = postSizeLimit - currentTextLength
  const isValidText = diff >= 0

  if (diff > 1000) return null

  return (
    <TooltipWrapper
      theme="dark"
      size="small"
      tooltipText={
        isValidText ? `You have ${diff} characters left` : 'Too many characters'
      }
    >
      <p
        data-testid="chars-counter"
        className={cn('mr-1.5 text-base text-gray-700', {
          'text-red-500': !isValidText,
        })}
      >
        {diff}
      </p>
    </TooltipWrapper>
  )
}

export default CharsCounter
